import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { withUser } from '../contexts/user';

const getInitials = (name) => name.split(' ').filter(x => x).splice(0, 2).map(s => s[0].toUpperCase()).join('');

function UserAvatar({ size, user }) {
  return (
    <div className={cx('user-avatar', size)}>
      {getInitials(user.currentUser.name)}
    </div>
  );
}

UserAvatar.defaultProps = {
  size: 'normal'
};

UserAvatar.propTypes = {
  size: PropTypes.string,
  user: PropTypes.object.isRequired
};

export default withUser(UserAvatar);
